import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=084cd31a&scoped=true"
import script from "./detailInfo.vue?vue&type=script&lang=js"
export * from "./detailInfo.vue?vue&type=script&lang=js"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=084cd31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084cd31a",
  null
  
)

export default component.exports